import React, {Component} from "react";
import {withNamespaces} from "react-i18next";
import BreadcrumbExtend from "../../../components/BreadcrumbExtend";
import {connect} from "react-redux";
import {deviceGroupActions} from "../../../actions/device-group.actions";
import DeviceGroupTable from "./_components/DeviceGroupTable";
import {modalActions} from "../../../actions/modal.actions";
import DeviceGroupForm from "./_forms/DeviceGroupForm";
import {claimTypes} from "../../../constants/claim.constants";

class DeviceGroupPage extends Component {

    componentDidMount() {
        const { dispatch } = this.props;
        dispatch(deviceGroupActions.getDeviceGroup());
    }

    handleChangeOrder = (direction, deviceGroupId) => {
        const { dispatch } = this.props;
        dispatch(deviceGroupActions.changeOrder(deviceGroupId, direction));
    };

    handleChangeDefault = (a,b,c) => {
        console.log(a,b,c);
    };

    handleOpenCreateModal = () => {
        const { t, dispatch } = this.props;
        const modalProps = {
            open: true,
            title: t('add_device-group'),
            component: <DeviceGroupForm submit={this.handleSubmitCreateForm}/>,
        };
        dispatch(modalActions.showModal({modalProps: modalProps, modalType: 'formModal' }));
    };

    handleSubmitCreateForm = (data) => {
        delete data['id'];
        const { dispatch } = this.props;

        dispatch(deviceGroupActions.addDeviceGroup(data));
        dispatch(modalActions.hideModal());
    };

    render() {
        const { t, list, user } = this.props;
        const deviceGroupCrud = user[`c_device-group.actions.crud`];

        const breadcrumb = [
            { value: 'device-group', path: '#' }
        ];


        return (
            <div>
                <BreadcrumbExtend items={breadcrumb}/>
                <h4>{ t('device-group') }</h4>
                <div className="card">
                    <div className="card-header">
                        <div className="button-group">
                            { deviceGroupCrud === claimTypes.READ_WRITE ? (
                                <button className="btn btn-success float-right btn-create" onClick={this.handleOpenCreateModal} >
                                    <i className="fas fa-plus"> </i> &nbsp; { t('create') }
                                </button>
                            ) : (<React.Fragment/>) }
                        </div>
                    </div>
                    <div className="card-body">
                        <DeviceGroupTable
                            list={list}
                            eventOnChangeOrder={this.handleChangeOrder}
                            eventOnChangeDefault={this.handleChangeDefault}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const { list } = state.deviceGroupReducer;
    const { user } = state.authenticationReducer;
    return {
        list,
        user
    }
};
export default withNamespaces()(connect(mapStateToProps)(DeviceGroupPage));
